import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

const Title = ({ children }) => {
  return <span className={classnames('text-2xl text-neutral-700 font-semibold', 'mb-2')}>{children}</span>;
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Title;
